import styled from 'styled-components'

export const FooterWrapper = styled.div<{ isWingie: boolean }>`
  ${({ isWingie }) =>
    isWingie &&
    `    
    @media (min-width: 768px) {
      /* More footer links alanını %113 genişlikte yap */
      [data-testid="footer-nav-more-item"] {
        display: block;
        width: 113%;
        max-width: 113%;
        flex: 1 0 113%;
        margin-left: -30px;
      }
    }
    /* Wingie'de etbis'i gizle */
    [data-testid*="etbis"],
    [class*="etbis"],
    [id*="etbis"],
    [class*="Etbis"],
    [id*="Etbis"],
    .etbis,
    a[href*="etbis"],
    img[alt*="etbis"],
    img[src*="etbis"],
    img[alt*="ETBIS"],
    img[src*="ETBIS"],
    a[href*="ETBIS"] {
      display: none !important;
      visibility: hidden !important;
      opacity: 0 !important;
      height: 0 !important;
      width: 0 !important;
    }
  `}
  [data-testid='footer-mobile-flags'] {
    img {
      width: 24px !important;
    }
  }

  /* Payment logos için mobil margin */
  @media (max-width: 767px) {
    .payment-logo {
      margin-bottom: 10px;
      width: 80px !important;
      height: 80px !important;
    }
    span:has(.payment-logos-text) {
      margin-top: -40px;
    }
  }
  @media (max-width: 375px) {
    .payment-logo {
      margin-bottom: 10px;
      width: 70px !important;
      height: 70px !important;
    }
    span:has(.payment-logos-text) {
      margin-top: -40px;
    }
  }
  @media (max-width: 320px) {
    .payment-logo {
      margin-bottom: 10px;
      width: 60px !important;
      height: 60px !important;
    }
    span:has(.payment-logos-text) {
      margin-top: -40px;
    }
  }
`
